import * as React from 'react'
import Translation from '../../containers/Translation';
import { T_LOADING } from '../../api/translations';
import useTranslation from '../../hooks/useTranslation';

import('./StatsFormStyles.scss')   



/*
 This component consists of team form statistics.
 */
export const StatsFormPresentation = (props:any) => {
    if( props.isValidHome && props.isValidAway ) {
        return (
            <div className="sr-grid sr-align-center statsForm">
                <div className="sr-cell sr-xs-1-3 home">
                    <div className="sr-content winsAndLossesPercentage">
                        {props.outcomePercentageHome}%
                    </div>
                    <div className="sr-content winsAndLossesChart">
                        {createOutcomesToChartElements(props.outcomePercentageHome)}
                    </div>
                    <div className="sr-content winsAndLosses">
                        {mapWinsAndLosses(props.winsAndLossesHome, props)}
                    </div>
                </div>
                <div className="sr-cell"></div>
                <div className="sr-cell sr-xs-1-3 away">
                    <div className="sr-content winsAndLossesPercentage">
                        {props.outcomePercentageAway}%
                    </div>
                    <div className="sr-content winsAndLossesChart">
                        {createOutcomesToChartElements(props.outcomePercentageAway)}
                    </div>
                    <div className="sr-content winsAndLosses">
                        {mapWinsAndLosses(props.winsAndLossesAway, props)}
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (
            <div className="sr-grid sr-align-center statsForm">
                <div className="sr-cell sr-stats-loading"><Translation tag={T_LOADING} /></div>
            </div>
        )
    }
}


/*
 Get all wins and losses and create the elements with the correct classname
 */
const mapWinsAndLosses = (winsAndLossesArray:Array<any> = [], props:any) => {
    return winsAndLossesArray.map((outcome:string, index:number) =>
        <div className={outcome} key={index}> <OutcomeTranslation outcome={outcome} /> </div>)
}


/*
 W, D and L which are the returned values in English will be mapped to the according translation
 */
const OutcomeTranslation = (props: { outcome: string }) => {
    const winShortText = useTranslation('StatisticsForm_winShort');
    const drawShortText = useTranslation('StatisticsForm_drawShort');
    const lossShortText = useTranslation('StatisticsForm_lossShort');

    if (props.outcome.charAt(0).toUpperCase() == 'W') {
        return <>{winShortText}</>
    }
    else if (props.outcome.charAt(0).toUpperCase() == 'D') {
        return <>{drawShortText}</>
    }
    else if (props.outcome.charAt(0).toUpperCase() == 'L') {
        return <>{lossShortText}</>
    }
}

/*
 Get all highlighted and non highlighted elements of the outcome chart
 */
const createOutcomesToChartElements = (winPercentage:number, numElements:number = 20) => {
    const numElementsHighlighted = winPercentage * numElements / 100
    const elements = []
    let highlighted = ""
    for (var i = 1; i <= numElements; i++) {
        if (i <= numElementsHighlighted) {
            highlighted = "highlighted"
        } else {
            highlighted = ""
        }
        elements.push(<div className={"beam " + highlighted} key={i}></div>)
    }
    return elements
}

export default StatsFormPresentation